import React from 'react';

function withActiveId(propKey = null) {
  return Component => (
    class Container extends React.Component {
      constructor(props) {
        super(props);
        this.state = {
          activeId: propKey ? this.props[propKey] : null,
        };
      }

      activateId = id => this.setState({ activeId: id });

      activateIdFunc = id => () => this.activateId(id);

      deactivate = () => this.setState({ activeId: null });

      render() {
        const newProps = {
          [`${propKey || 'activeId'}`]: this.state.activeId,
          activateId: this.activateId,
          activateIdFunc: this.activateIdFunc,
          deactivate: this.deactivate,
        };

        return <Component {...this.props} {...newProps} />;
      }
    }
  );
}

export default withActiveId;
